import { render, staticRenderFns } from "./ot-currency-field-wrapper.vue?vue&type=template&id=d29d2750&scoped=true&"
import script from "./ot-currency-field-wrapper.vue?vue&type=script&lang=ts&"
export * from "./ot-currency-field-wrapper.vue?vue&type=script&lang=ts&"
import style0 from "./ot-currency-field-wrapper.vue?vue&type=style&index=0&id=d29d2750&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d29d2750",
  null
  
)

export default component.exports